var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboardIconLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.48797 11.321L6.73376 13.5837L8.99626 12.8294L16.1613 5.6644C16.3693 5.45641 16.3693 5.11818 16.1613 4.9102L15.4071 4.15599C15.1991 3.948 14.8609 3.948 14.6529 4.15599L7.48797 11.321Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.001 9.33264H14.0011L9.75039 13.5837C9.633 13.7 9.49014 13.7885 9.33333 13.8407L7.07072 14.596C6.95988 14.6333 6.84677 14.6504 6.73366 14.6504C6.45519 14.6504 6.1822 14.5405 5.97946 14.3379C5.69361 14.053 5.59443 13.6295 5.72135 13.2465L6.47555 10.984C6.52889 10.8272 6.61627 10.6842 6.73366 10.567L7.96789 9.33273H4.06673C3.47896 9.33273 3 9.81169 3 10.3995V18.9333C3 19.5221 3.47896 20 4.06673 20H19.0009C19.5897 20 20.0676 19.5221 20.0676 18.9333V10.3995C20.0676 9.81169 19.5897 9.33273 19.0009 9.33273L19.001 9.33264ZM16.3342 16.7997H7.80042C7.506 16.7997 7.26706 16.5608 7.26706 16.2664C7.26706 15.9719 7.506 15.733 7.80042 15.733H16.3342C16.6286 15.733 16.8676 15.9719 16.8676 16.2664C16.8676 16.5608 16.6286 16.7997 16.3342 16.7997ZM16.3342 13.5995H13.134C12.8396 13.5995 12.6007 13.3606 12.6007 13.0662C12.6007 12.7718 12.8396 12.5328 13.134 12.5328H16.3342C16.6286 12.5328 16.8676 12.7707 16.8676 13.0662C16.8676 13.3617 16.6286 13.5995 16.3342 13.5995Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardIconLight);
export default __webpack_public_path__ + "static/media/DashboardIconLight.727ca5e09422c96e538b884246d74651.svg";
export { ForwardRef as ReactComponent };